// extracted by mini-css-extract-plugin
export default {"column":"new-well-column_column__DJW3M"};